<template>
  <div :class="$style.container">
    <header
      :class="$style.header"
    >
      <slot name="header">
        <iButton
          type="primary"
          @click="$router.push('edit')"
        >{{ $t('pages.rest.buttons.edit') }}</iButton>
      </slot>
    </header>

    <section :class="$style.main">
      <iSpin
        v-if="$page.resource.pending"
        fix
      />
      <slot/>
    </section>

    <slot name="section"/>

    <section v-if="false" :class="$style.versions">
      <h2>Historique</h2>
      <VersionsTable
        :config="$page.config"
        :loading="$page.versions.pending"
        :versions="$page.versions.all"/>
    </section>
  </div>
</template>

<script>
import VersionsTable from '../versions/VersionsTable.vue';

export default {
  name: 'LayoutId',
  components: { VersionsTable },
  inject: ['$page'],
};
</script>

<style lang="scss" module>
.container {
  margin: 24px;
  padding: 24px;
  background: #fff;
}

.header {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.main {
  position: relative;
}

.versions {
  h2 {
      margin: 12px 0;
  }
}
</style>
